export enum TransferListEntryOrigin {
  BUS1 = 'BUS1',
  BUS2 = 'BUS2'
}
